/**
 * Cloze-Renderer als pure Functions — testbar ohne DOM.
 *
 * cards.json kann cloze-Karten in zwei Shapes haben:
 *   1. SCHEMA-konform: card.text mit {{c1::...}}-Markern
 *   2. Legacy aus build_cards.py: card.front mit Markern + card.back als gerendertes Ergebnis
 */
import type { ClozeCard } from '$types/card';

export interface ClozeRenderOptions {
  hidden: boolean;
  hiddenPlaceholder?: string;
}

const CLOZE_PATTERN = /\{\{c(\d+)::(.+?)(?:::([^}]*))?\}\}/g;

export function renderCloze(text: string, opts: ClozeRenderOptions): string {
  if (!text) return '';
  return text.replace(CLOZE_PATTERN, (_m, _idx, content, hint) => {
    if (opts.hidden) {
      const ph = opts.hiddenPlaceholder ?? '[…]';
      return hint
        ? `<span class="cloze-hidden">[${hint}]</span>`
        : `<span class="cloze-hidden">${ph}</span>`;
    }
    return `<span class="cloze-revealed">${content}</span>`;
  });
}

export function clozeSourceText(card: ClozeCard): string {
  return card.text ?? card.front ?? '';
}

export function clozeAnswerText(card: ClozeCard): string {
  if (card.text) {
    return card.text.replace(CLOZE_PATTERN, (_m, _idx, content) => content);
  }
  return card.back ?? '';
}

export function clozePromptText(card: ClozeCard): string {
  const src = clozeSourceText(card);
  return src.replace(CLOZE_PATTERN, '…');
}

export function stripHtml(html: string): string {
  return html
    .replace(/<[^>]+>/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}
